import React from 'react'
import ReactSkeleton, { SkeletonProps as ReactSkeletonProps } from 'react-loading-skeleton'

type SkeletonProps = ReactSkeletonProps

const SkeletonLoading = ({ ...props }: SkeletonProps): JSX.Element => {
  return <ReactSkeleton {...props} />
}

export default SkeletonLoading
